import { render } from "./templateSetting.vue?vue&type=template&id=3b008e4a&scoped=true"
import script from "./templateSetting.vue?vue&type=script&lang=js"
export * from "./templateSetting.vue?vue&type=script&lang=js"

import "./templateSetting.vue?vue&type=style&index=0&id=3b008e4a&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b008e4a"]])

export default __exports__